import { useMemo } from "react";
import { getDevice } from "@therms/web-js";
//#region src/hooks/useDevice.ts
function useDevice() {
	return useMemo(() => {
		const device = getDevice();
		return {
			mac: device.mac,
			name: device.name,
			os: device.os,
			type: device.type,
			uuid: device.uuid
		};
	}, []);
}
//#endregion
export { useDevice };

//# sourceMappingURL=useDevice.js.map